import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function ContactsIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <circle cx="28" cy="72" r="8" fill={c.p300} />
      <path d="M16 108c0-9 5-16 12-16s12 7 12 16z" fill={c.p300} />
      <circle cx="132" cy="72" r="8" fill={c.a300} />
      <path d="M120 108c0-9 5-16 12-16s12 7 12 16z" fill={c.a300} />
      <rect
        x="38"
        y="38"
        width="84"
        height="88"
        rx="14"
        fill={c.n0}
        stroke={c.p200}
        strokeWidth="2"
      />
      <circle cx="80" cy="64" r="12" fill={c.p500} />
      <path d="M58 100c0-12 10-19 22-19s22 7 22 19z" fill={c.p500} />
      <rect x="56" y="108" width="48" height="6" rx="3" fill={c.p200} />
    </Frame>
  );
}
